import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import toast from 'react-hot-toast';

let today = new Date();
today.setDate(today.getDate() -1);
let yesterday = new Date(today);
yesterday.setDate(today.getDate() -1);

export const sweepsSlice = createSlice({
  name: 'sweeps',
  initialState: {
    startDate: yesterday.toISOString().split('T')[0],
    endDate: today.toISOString().split('T')[0],
    sweepsData: '', 
    Processing: false,
    ErrorMessage: '',
    displayRow:'',
  },
  reducers: {
    updateStartDate: (state, action)  => {
      state.startDate = action.payload;
    },
    updateEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    "clearSweepsData": (state, action) => {
      console.log('in clearsweepsData');
      state.sweepsData = action.payload;
    },
    "sweeps/updatesweepsData": (state, action) => {
      updatesweepsData(state,action);
    },
    "updatesweepsData": (state, action) => {
      console.log('in updatesweepsDtta');
      console.log(action.payload)
      state.sweepsData = action.payload;
      state.Processing = false;
      if (action.payload.length < 1) {toast('No Results Found')};
    },
    "getData": (state, action) => {
     console.log(action.payload);
     state.sweepsData  = action.payload;
    },
    "sweeps/updateProcessing": (state, action) => {
      console.log('in sweeps/updateProcessing');
      updateProcessing(state,action);  
    },
    "updateProcessing": (state, action) => {
      console.log('in updateProcessing');
      state.Processing = action.payload;
      state.LoginMessage = (action.payload === false) ? 'Login Failed' : '';
    },
    "showRow": (state, action) => {
      state.displayRow = action.payload;
    },
    "completeResendingsweep" : (state, action) => {
      console.log('in completresendingsweep');
      state.Processing = false;
      if (action.payload === '200') {
        state.ErrorMessage = 'Resend Successful';
        toast.success('Resend Successful');
      }
      else
      {
        state.ErrorMessage = 'Resend Failed';
        toast.error('Resend Failed');
      }

    },

  },
});

export const { 
  updateProcessing, 
  completeResendingsweep,
  updatesweepsData,
  clearSweepsData,
  getData,
  updateEndDate,
  updateStartDate, 
  Processing, 
  ErrorMessage,
  showRow 
} = sweepsSlice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
export const getDataAsync = (startDate,endDate,jwt,requestType) => dispatch => {
  let date1 = new Date(startDate);
  let date2 = new Date(endDate);
  let Difference_In_Time = date2.getTime() - date1.getTime();
  console.log(typeof Difference_In_Time);
  if (Difference_In_Time < 0) {
    toast.error('End Date must be the same or later than Start Date');
    return;
  }
  dispatch(updateProcessing(true));
  dispatch(getDataAPI({startDate,endDate,jwt,requestType}))
};

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectSweepsData = state => state.sweeps;

export const resendOrmAsync = (id) => dispatch => {
  dispatch(resendORM({id}));
}

export const resendORM = createAsyncThunk(
  'loginAPIcall', 
  async (Payload,thunkAPI ) => {
  try {
    const { jwt } = thunkAPI.getState().login
    thunkAPI.dispatch(updateProcessing(true));
    thunkAPI.dispatch(clearSweepsData([]));
    const id  = Payload.id;

    const options = {
      'mode' : 'cors',
      'method' : 'get',
      headers: { 
        "Authorization" : `Bearer ${jwt}`,  
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
  			'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    };
  console.log(options);
  const url = `${window.configs.api_server}/resendORM?id=${id}`;

  console.log(url);

  let response = await fetch(url,options)
  response = await response
  console.log (JSON.stringify(response));
  console.log(`response from resending sweep is ${response.status}`);
  thunkAPI.dispatch(completeResendingsweep(response.status));
 
  } catch (error) {
    console.error(error);
  }
  return;
})



export const getDataAPI = createAsyncThunk(
  'loginAPIcall', 
  async (Payload,thunkAPI) => {
  try {

    thunkAPI.dispatch(updateProcessing(true));
    thunkAPI.dispatch(clearSweepsData([]));

    let { startDate, endDate, jwt } = Payload;
 

    console.log(Payload);
    const options = {
      'mode' : 'cors',
      'method' : 'get',
      headers: { 
        "Authorization" : `Bearer ${jwt}`,  
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
  			'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    };

console.log(options);
  let url = ''
  
  url = `${window.configs.api_server}/list/sweeps?startDate=${startDate}&endDate=${endDate}`;

  
  console.log(url);

  let response = await fetch(url,options)
  response = await response
  response = await response.json();
  thunkAPI.dispatch(updatesweepsData(response));
  thunkAPI.dispatch(updateProcessing(false));

 
  } catch (error) {
    console.error(error);
  }

  return;
})

export default sweepsSlice.reducer;
